import { render } from "./CreateBill.vue?vue&type=template&id=cb3686c4&scoped=true"
import script from "./CreateBill.vue?vue&type=script&lang=js"
export * from "./CreateBill.vue?vue&type=script&lang=js"

import "./CreateBill.vue?vue&type=style&index=0&id=cb3686c4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3686c4"]])

export default __exports__